export default __webpack_public_path__ + "static/12.methodist presechool-08ac9934ebe9691c12728754926c62d0.png";